module.exports = __webpack_public_path__ + "img/download-google-play.cce959a9.png";